import * as PhosphorIcons from '@phosphor-icons/react';

/**
 * IconResolver — resolves an icon name string from data to an actual Phosphor React icon.
 * Falls back to CircleDashed if unknown.
 */
export default function IconResolver({ name, size = 24, weight = 'duotone', className = '' }) {
  const Icon =
    PhosphorIcons[name] ||
    PhosphorIcons.CircleDashed;
  return <Icon size={size} weight={weight} className={className} />;
}
